import { usePathname, useSearchParams } from 'next/navigation';
import {
  parsePathnameToSearchType,
  type SearchType,
} from '@/lib/publicSearchPaths';

export type { SearchType };

export function useSearchType(): SearchType {
  const pathname = usePathname();
  const params = useSearchParams();

  const fromPath = parsePathnameToSearchType(pathname ?? '');
  if (fromPath) return fromPath;

  const fromParams = params?.get('searchType') as SearchType | null;
  if (fromParams) return fromParams;

  const isMemberDetailPage = /\/members\/.+/.test(pathname ?? '');
  if (isMemberDetailPage) return 'members';

  return 'animal';
}
